import _ from 'lodash';
import {Platform} from 'react-native';
import * as omniture from '@mmt/legacy-commons/Common/utils/OmnitureTrackerUtils';
import {VAR_PAGE_NAME} from '@mmt/legacy-commons/Common/utils/OmnitureTrackerUtils';
import { setDataInStorage, getDataFromStorage } from '@mmt/legacy-commons/AppState/LocalStorage';
import fecha from 'fecha';
import {diffDays, today} from '@mmt/legacy-commons/Helpers/dateHelpers';
import {
  getDataFromAsynStorage,
  setDataToAsyncStorage,
  HARD_LOGIN_FLOW,
  SOFT_LOGIN_FLOW,
  ANOTHER_TYPE_LOGIN_FLOW,
  TRAVELERS_CD_PROMT,
  TRAVELERS_FC_PROMT,
  LISTING_NEARBY_STATIONS_BOTTOMSHEET,
  REVIEW_FARE_BREAKUP,
  LISTING_CONNECTED_TRAVEL_EVENTS,
  NEARBY_DATES_EVENTS,
  RAILS_ERROR_FLOW,
  RAILS_CONNECTED_TRAVEL_POKUS_CONSTANTS,
  LISTING_PAGE_TRACKING_KEY,
  RAIL_TRACKING_DATA_EVAR_47,
} from './Utils/RailsConstant';
import {
  _selectedLanguageProvider,
  getSelectedLanguageName,
  langCodeToName
} from './vernacular/VernacularConfig';
import { EVAR_71 } from '@mmt/legacy-commons/Common/utils/OmnitureTrackerUtils';
import {
  getCanLoadListingv3,
  getIfCanShowBNPP,
  getIfToShowFCTGTogether,
  getRailsErrorHandlingConfig,
  getRailsFcPremiumPokus,
  showRailsReviewIrctcBs,
} from './RailsAbConfig';
import RAIL_EVENTS, { IRCTC } from './RailsOmnitureTracker';
import { getRailsLanguageByKey } from './vernacular/AppLanguage';


const getEvar37 = () => {
  return {
    m_v37: `domain_sbu:india|domain_country:in|domain_currency:inr|domain_language:${getRailsLanguageByKey("cookieCode")}`
  }
}

// If there are multiple props/var needs to be tracked then pass a dictionary or if only prop54
// needs to be tracked pass prop54 value as string
const _prepareTrackingData = (data) => {
  if (_.isEmpty(data)) {
    return {};
  }
  let trackingData = data;
  if (_.isString(trackingData)) {
    trackingData = {
      [omniture.PROP_54]: data
    };
  }
  return trackingData;
};

const _trackEvent = (pageName, data, isLoading = false) => {
  // Wrapping inside a setTimeout to prevent any omniture latency/erros to effect the main logic
  setTimeout(() => {
    omniture.trackOmniture(pageName, {
      [omniture.VAR_LOB_KEY]: 'rails',
      [omniture.VAR_CHANNEL]: 'rails funnel',
      ..._prepareTrackingData(data),
      ...Platform.OS === 'web' ? getEvar37() : {}
    }, isLoading);
  }, 0);
};


const _getFunnelLanguageVar = async (pageName) => {
  const Language = getSelectedLanguageName();
  const language = Language.toLowerCase()
  const pageInfo = `mob_rail_language_${language}_${pageName}`
  return {
    [omniture.PROP_61]: Language,
    [omniture.EVAR_59]: pageInfo
}
}

let _railsEVars = {};



export const _getEvarKey = () => {
  if (Platform.OS === 'web') {
    return omniture.EVAR_47;
  }
  return omniture.EVAR_97;
};

const evar47or97 = _getEvarKey();

export const trackEvar71Event = (pageName, event) => {
  const pageObject = getPageObject(pageName);
  let evar71 = _railsEVars[omniture.EVAR_71] || '';
  evar71 = event;

  _railsEVars = {
    ..._railsEVars,
    [omniture.EVAR_71]: evar71,
  };
  _trackEvent(pageName, {
    ..._railsEVars,
    ...pageObject,
  });
};

export const updateEvarFromLocalStorage = async () => {
  try {
    const newData = await getDataFromStorage(RAIL_TRACKING_DATA_EVAR_47);
    if (Object.keys(_railsEVars)?.length === 0 && newData) {
      _railsEVars = {
        ..._railsEVars,
        [evar47or97]: newData,
      };
    }
  } catch (error) {
    console.error('Error updating eVar:', error);
  }
};

export const updateEvar71Variable = (event) => {
  _railsEVars = {
    [omniture.EVAR_71]: event,
  };
};

export const createFunnelVars = ({src, dest, deptDate}) => {
  const srcDest = `${src.cityName}-${dest.cityName}`;
  const srcDestCodes = `${src.code}-${dest.code}`;
  const deptDateFormatted = fecha.format(deptDate, 'DD/MM/YYYY');
  const apDateDiff = diffDays(deptDate, today());
  const appendEvar3 = src.language === 'eng' && dest.language === 'eng';
  _railsEVars = {
    ..._railsEVars,
    ...(appendEvar3 && { [omniture.VAR_SRC_DEST]: srcDest }),
    [omniture.VAR_SRC_DEST_CODES]: srcDestCodes,
    [omniture.VAR_START_DATE]: deptDateFormatted,
    [omniture.VAR_AP]: apDateDiff
  };
  return _railsEVars;
};

export const getRailsOmnitureEVars = () => _railsEVars;


export const trackAlternateStationsPageEvent = (event) => {
  const pageObject = getPageObject('mob_rail_alternate_stations');
  _trackEvent('mob_rail_alternate_stations', {
    ...pageObject,
    [omniture.PROP_61]: event
  });
};

export const trackPremierUser = (pageName) => {
  if (_railsEVars[omniture.EVAR_99] !== 'BR_Prem|') {
    _railsEVars[omniture.EVAR_99] = 'BR_Prem|';
    _trackEvent(pageName, {
      ..._railsEVars,
    });
  }
};

export const trackClickNoDirectTrainsFound = (event) => {
  const pageObject = getPageObject('mob_rail_listing_v2_noTrainsFound_TrainsExistOnOtherDates');
  _trackEvent('mob_rail_listing_v2_noTrainsFound_TrainsExistOnOtherDates', {
    ...pageObject,
    [omniture.PROP_61]: event
  });
};

export const trackAlternateStationsPageLoad = async () => {
  const pageObject = getPageObject('mob_rail_alternate_stations');
  const data =await _getFunnelLanguageVar('alternate_stations')
  _trackEvent('mob_rail_alternate_stations', {
    ...data,
    ...pageObject,
    ..._railsEVars,
  });
};

export const trackRetryEvent = (event, pageName = 'mob_rail_booking_retry') => {
  const pageObject = getPageObject(pageName);
  _trackEvent(pageName, {
    ...pageObject,
    [omniture.PROP_61]: event
  });
};

export const trackRetryPageLoad = async (pageName = 'mob_rail_booking_retry') => {
  const pageObject = getPageObject(pageName);
  const data = await _getFunnelLanguageVar('booking_retry')
  _trackEvent(pageName, {
    ...data,
    ...pageObject
  });
};

export const trackLanguageChangeEvent = (languageCode) => {
  trackLandingEvent({
    [omniture.PROP_61]: `mob_rail_landing_${langCodeToName(languageCode)}_selected`
  });
};

export const trackLanguageChangeButtonClick = () => {
  trackLandingEvent({
    [omniture.PROP_61]: `mob_rail_landing_Language_clicked`
  });
};

export const trackLandingEvent = (data) => {
  _trackEvent('mob_rail_landing', data);
};

export const trackLandingPageLoad = async () => {
  const data = await _getFunnelLanguageVar('landing')
  const showFCTGTogether = getIfToShowFCTGTogether();
  updateEvar47or97Variable(`${RAIL_EVENTS.LANDING.RAILS_FC_TG_V1}_${showFCTGTogether}`);
  try {
    const isV3Listing = getCanLoadListingv3();
    updateEvar47or97Variable(`${RAIL_EVENTS.LISTING.RAILS_LOAD_TIME_IMPROVEMENT}_${isV3Listing}`);
    removeEventFromEvar47or97Variable(
      `${RAIL_EVENTS.LISTING.RAILS_LOAD_TIME_IMPROVEMENT}_${!isV3Listing}`,
    );
  } catch (error) {
    //ignore, to be removed
  }
  _trackEvent('mob_rail_landing', {
    ..._railsEVars,
    ...data,
    [omniture.VAR_PAGE_NAME]: 'mob_rail_landing'
  }, true);
};

export const trackLandingClickEvent = (event) => {
  const pageObject = getPageObject('mob_rail_landing');
  _trackEvent('mob_rail_landing', {
    ..._railsEVars,
    [omniture.PROP_61]: event,
    ...pageObject
  });
};


export const trackAvailabilityPageLoad = () => {
  _trackEvent('mob_rail_availability_check', {
    [omniture.VAR_PAGE_NAME]: 'mob_rail_availability_check'
  });
};

export const trackListingEvent = (data) => {
  _trackEvent('mob_rail_listing', data);
};

export const trackPageName = (pageName) => {
  _trackEvent(pageName, '');
};

export const trackAvailabilityPageEvent = (data) => {
  _trackEvent('mob_rail_availability_check', data);
};
export const trackListingLoad = ({
  isLoggedIn, advancePurchase
}) => {
  _railsEVars = {
    ..._railsEVars,
    [omniture.VAR_USER_LOGIN_STATUS]: isLoggedIn,
    [omniture.VAR_AP]: advancePurchase
  };
  trackListingEvent(_railsEVars);
};

export const trackAvailLoad = async (advancePurchase) => {
  const data = await _getFunnelLanguageVar()
  _railsEVars = {
    ..._railsEVars,
    ...data,
    [omniture.VAR_AP]: advancePurchase
  };
  trackAvailabilityPageEvent(_railsEVars);
};

export const trackTravellerPageEvent = (data) => {
  const pageObject = getPageObject('mob_rail_travellers');
  _trackEvent('mob_rail_travellers', {
    ..._railsEVars,
    [omniture.PROP_61]: data,
    ...pageObject
  });
};

const getPageSource = (pageSource) => {
  switch (pageSource) {
    case 'whatsapp':
    case 'WHATSAPP':
    case 'WA':
    case 'wa':
      return 'whatsapp_rails'
    default:
      return pageSource
  }
}

export const trackTravellerPageLoad = async (commonData, pageSource = '') => {
  const data = await _getFunnelLanguageVar('travellers')
  const pageObject = getPageObject('mob_rail_travellers');
  const canShowBnppPokus = getIfCanShowBNPP(true);
  if (canShowBnppPokus) {
      updateEvar47or97Variable(`${RAIL_EVENTS.TRAVELLER.RAILS_TRAVELLERS_BNPP}_${canShowBnppPokus}`);
      removeEventFromEvar47or97Variable(
        `${RAIL_EVENTS.TRAVELLER.RAILS_TRAVELLERS_BNPP}_${!canShowBnppPokus}`,
      );
  } else {
    removeEventFromEvar47or97Variable(`${RAIL_EVENTS.TRAVELLER.RAILS_TRAVELLERS_BNPP}_true`);
    removeEventFromEvar47or97Variable(`${RAIL_EVENTS.TRAVELLER.RAILS_TRAVELLERS_BNPP}_false`);
  }
  removeEventFromEvar47or97Variable(`${RAIL_EVENTS.TRAVELLER.RAILS_TRAVELLERS_FC_WITH_BNPP}n`);
  removeEventFromEvar47or97Variable(`${RAIL_EVENTS.TRAVELLER.RAILS_TRAVELLERS_FC_WITH_BNPP}y`);

  removeEventFromEvar47or97Variable(RAILS_ERROR_FLOW.ERROR_HANDLING_OFF);
  removeEventFromEvar47or97Variable(RAILS_ERROR_FLOW.ERROR_HANDLING_ON);
  const showErrorFlow = await getRailsErrorHandlingConfig(true);
  if (showErrorFlow != null) {
    if (showErrorFlow) {
      updateEvar47or97Variable(RAILS_ERROR_FLOW.ERROR_HANDLING_ON);
    } else {
      updateEvar47or97Variable(RAILS_ERROR_FLOW.ERROR_HANDLING_OFF);
    }
  } 

  _trackEvent('mob_rail_travellers', {
    [VAR_PAGE_NAME]: 'mob_rail_travellers',
    ...data,
    ...pageObject,
    [omniture.PROP_63]: commonData,
    ..._railsEVars,
    [EVAR_71]: getPageSource(pageSource)
  }, true);
};

export const trackUserValidation = (pageName, data) => {
  _trackEvent(pageName, data);
};

export const trackAndSetDataForReviewPageLoad = async (commonData) => {
  const data = await _getFunnelLanguageVar('review')
  const pageObject = getPageObject('mob_rail_review');
  setDataToAsyncStorage('RAIL_TRACKING_DATA', JSON.stringify({railBookingEvars: _railsEVars, railCommonTrackingData: commonData}));
  _trackEvent('mob_rail_review', {
    ...pageObject,
    ...data,
    ..._railsEVars,
    [omniture.PROP_63]: commonData
  }, true);
};

export const trackRailsTyPageFailedPageEvent = (data) => {
  const analizeData = {
    [omniture.PROP_61]: data,
    [VAR_PAGE_NAME]: 'mob_rail_Thank_You_Failure'
  };
  _trackEvent('mob_rail_Thank_You_Failure', analizeData);
};

export const trackRailsRefundInitiatedPageEvent = (data) => {
  const analizeData = {
    [omniture.PROP_61]: data,
    [VAR_PAGE_NAME]: 'mob_rail_failure_refund_initiated'
  };
  _trackEvent('mob_rail_failure_refund_initiated', analizeData);
};

export const trackRailsRefundInitiatedPageLoad = () => {
  _trackEvent('mob_rail_failure_refund_initiated', {
    [VAR_PAGE_NAME]: 'mob_rail_failure_refund_initiated'
  });
};

export const trackReviewErrorPage = (error) => {
  _trackEvent('mob_rail_review ', {
    [omniture.VAR_ERROR_KEY]: `TRAINS:Review_${error}`
  });
};

export const trackReviewPageStatusChange = (trackEvent) => {
  _trackEvent('mob_rail_review', {
      [omniture.EVAR_60] : trackEvent
  });
}

export const trackReviewPageStatusChangeBackClick = () => {
  _trackEvent('mob_rail_review',{
      [omniture.PROP_61] : 'mob_rail_review_FCTG_card_clicked'
  });
}

export const trackReviewPageBackPress = () => {
  _trackEvent('mob_rail_review', {
      [omniture.PROP_61] : 'mob_rail_review_softback_click'
  });
}

export const trackReviewPageClickEvent = (event) => {
  const pageName = 'mob_rail_review';
  const pageObject = getPageObject(pageName);
  _trackEvent(pageName, {
    ...pageObject,
    [omniture.PROP_61]: event,
  });
};

const getPageObject = pageName => ({
  [VAR_PAGE_NAME]: pageName,
  pageName,
  m_pagename: pageName
});

export const trackThankYouPageSuccessPageLoad = async (mmtId,isBNPPBooking) => {
  try {
  const data = await _getFunnelLanguageVar('Thank_You_Success')
  const pageObject = getPageObject('mob_rail_Thank_You_Success');
    const trackingData = JSON.parse(await getDataFromAsynStorage('RAIL_TRACKING_DATA')) || {};
    const {railBookingEvars, railCommonTrackingData} = trackingData;
    _railsEVars = railBookingEvars;
    const successPageName = 'mob_rail_Thank_You_Success';
    if (checkIfEvarPresent(`${RAIL_EVENTS.THANK_YOU.RAILS_BNPP}_true`)){
      updateEvar47or97Variable(`${RAIL_EVENTS.THANK_YOU.RAILS_BNPP}_${isBNPPBooking ? 'used' : 'notused'}`);
    }
    const eventObj = {
      ...pageObject,
      ...railBookingEvars,
      ...data,
      [omniture.PROP_63]: railCommonTrackingData,
      m_v16: mmtId,
      purchaseID: mmtId,
      m_purchase: 1
    };
    if (Platform.OS === 'web') {
      _trackEvent(successPageName, eventObj, true);
      _trackEvent("mob_rail_TY", eventObj, true);
    } else {
      _trackEvent(successPageName, eventObj);
    }
  } catch (e) {
    console.log('error is', e);
  }
};

export const trackThankYouPageFailurePageLoad = async (isBNPPBooking = false) => {
  try {
  const data = await _getFunnelLanguageVar('Thank_You_Failure')
  const pageObject = getPageObject('mob_rail_Thank_You_Failure');
    const trackingData = JSON.parse(await getDataFromAsynStorage('RAIL_TRACKING_DATA'));
    const {railBookingEvars, railCommonTrackingData} = trackingData || {};
    _railsEVars = railBookingEvars;
    if (checkIfEvarPresent(`${RAIL_EVENTS.THANK_YOU.RAILS_BNPP}_true`)){
      updateEvar47or97Variable(`${RAIL_EVENTS.THANK_YOU.RAILS_BNPP}_${isBNPPBooking ? 'used' : 'notused'}`);
    }
    _trackEvent('mob_rail_Thank_You_Failure', {
      ...data,
      ...pageObject,
      ...railBookingEvars,
      [omniture.PROP_63]: railCommonTrackingData
    });
  } catch (e) {
    console.log('error is', e);
  }
};

export const trackRailPaymentDone = async () => {
try {
   const data = await getDataFromAsynStorage('RAIL_TRACKING_DATA');
   let railBookingEvarData = {}
   if(data){
    const trackingData = JSON.parse(data);
    railBookingEvarData = trackingData?.railBookingEvars || {};
   }
    _trackEvent('mob_rail_payments', {
      [VAR_PAGE_NAME]: 'mob_rail_payments',
      m_c67: 'callback_from_pg_received',
      ...railBookingEvarData,
    });
  } catch (error) {
    
  }
};

export const trackRailNavigateToIrctcDone = (tryCount) => {
  _trackEvent('mob_rail_payments', {
    [VAR_PAGE_NAME]: 'mob_rail_payments',
    m_c67: `navigate_to_irctc_done_${tryCount}`
  });
};


export const trackRailIrctcPasswordAfterPaymentLoad = async () => {
  const data = await _getFunnelLanguageVar('irctc_password_after_payments')
  const trackingData = JSON.parse(await getDataFromAsynStorage('RAIL_TRACKING_DATA')) || {};
  const { railBookingEvars } = trackingData;
  _trackEvent('mob_rail_irctc_password_after_payments', {
    [VAR_PAGE_NAME]: 'mob_rail_irctc_password_after_payments',
    ...data,
    ...railBookingEvars
  }, true);
};

export const trackReviewPageEvent = (data) => {
  _trackEvent('mob_rail_review', data);
};

export const trackPageLoad = async (pageName) => {
  const data = await _getFunnelLanguageVar('irctc_forgot_username')
  const pageObject = getPageObject(pageName);
  _trackEvent(pageName, {
    ...pageObject,
    ...data,
    [VAR_PAGE_NAME]: pageName,
    ..._railsEVars
  });
};

export const trackVerifyContactDetailsPageLoad = (pageName) => {
  _trackEvent(pageName, {
    [VAR_PAGE_NAME]: pageName,
  }, true);
}

export const trackHotelCrossSellEvent = (pageName, data) => {
  _trackEvent(pageName, data);
};


export const trackEnterUserNameEvent = (event) => {
  const pageObject = getPageObject('mob_rail_listing_irctc_userid_popup_RN');
  _trackEvent('mob_rail_listing_irctc_userid_popup_RN', {
    ...pageObject,
    [omniture.PROP_61]: event,
    ..._railsEVars
  });
};

export const trackVerifyIrctcUsernameEvent = (event) => {
  const pageObject = getPageObject('mob_rail_listing_irctc_userid_verify_username');
  _trackEvent('mob_rail_listing_irctc_userid_verify_username', {
    ...pageObject,
    [omniture.PROP_61]: event,
    ..._railsEVars
  });
};

export const trackVerifyIrctcUsernameEventV2 = (event) => {
  const pageObject = getPageObject('mob_rail_listing_irctc_userid_verify_username');
  _trackEvent('mob_rail_listing_irctc_userid_verify_username', {
    ...pageObject,
    [omniture.PROP_61]: event,
    ..._railsEVars
  });
};

export const trackIrctcUserVerified = (event) => {
  const pageObject = getPageObject('mob_rail_listing_irctc_userid_verified');
  _trackEvent('mob_rail_listing_irctc_userid_verified', {
    ...pageObject,
    [omniture.PROP_61]: event,
    ..._railsEVars
  });
};

export const trackIrctcPopupError = (event) => {
  const pageObject = getPageObject(RAIL_EVENTS.IRCTC.MOB_RAILS_IRCTC_PAGE);
  _trackEvent(RAIL_EVENTS.IRCTC.MOB_RAILS_IRCTC_PAGE, {
    ...pageObject,
    [omniture.VAR_ERROR_KEY]: event,
    ..._railsEVars,
  });
};

export const trackForgotUsernameEvent = (event) => {
  const pageObject = getPageObject('mob_rail_listing_irctc_forgot_username');
  _trackEvent('mob_rail_listing_irctc_forgot_username', {
    ...pageObject,
    [omniture.PROP_61]: event,
    ..._railsEVars
  });
};

export const trackUsernameSentEvent = (event) => {
  const pageObject = getPageObject('mob_rail_listing_irctc_username_sent');
  _trackEvent('mob_rail_listing_irctc_username_sent', {
    ...pageObject,
    [omniture.PROP_61]: event,
    ..._railsEVars
  });
};

export const trackRequestNewPasswordEvent = (event) => {
  const pageObject = getPageObject('mob_rail_listing_irctc_forgot_password');
  _trackEvent('mob_rail_listing_irctc_forgot_password', {
    ...pageObject,
    [omniture.PROP_61]: event,
    ..._railsEVars
  });
};

const listingLoadRemoveEvar47or97Events = () => {
  Object.keys(RAILS_CONNECTED_TRAVEL_POKUS_CONSTANTS)?.forEach((key) => {
    removeEventFromEvar47or97Variable(RAILS_CONNECTED_TRAVEL_POKUS_CONSTANTS?.[key]?.omnitureKey);
  });
  // Please add the events to be removed from evar47or97 on listing load in this array
  const eventsToRemove = [
    LISTING_CONNECTED_TRAVEL_EVENTS.ctv1,
    LISTING_CONNECTED_TRAVEL_EVENTS.ctv2,
    LISTING_CONNECTED_TRAVEL_EVENTS.ctV1Card,
    LISTING_CONNECTED_TRAVEL_EVENTS.ctV2Card,
    RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_DEPLETION_V1,
    RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_DEPLETION_V2,
    RAIL_EVENTS.TRAVELLER.RAILS_DYNAMIC_TRAIN_PERSAUSION,
    `${RAIL_EVENTS.REVIEW.IRCTC_PASS_BOTTOMSHEET_EVENT}_${showRailsReviewIrctcBs() || 0}`,
    `${RAIL_EVENTS.TRAVELLER.RAILS_FC_PREMIUM_EVENT}${getRailsFcPremiumPokus() || 0}`,
  ];
  eventsToRemove.map((event) => {
    removeEventFromEvar47or97Variable(event);
  });
};

export const travelerLoadRemoveEvar47or97Events = () => {
  try {
    const eventsToRemove = [
      `${RAIL_EVENTS.REVIEW.IRCTC_PASS_BOTTOMSHEET_EVENT}_${showRailsReviewIrctcBs() || 0}`,
      `${RAIL_EVENTS.TRAVELLER.RAILS_FC_PREMIUM_EVENT}${getRailsFcPremiumPokus() || 0}`,
    ];
    eventsToRemove.forEach((event) => {removeEventFromEvar47or97Variable(event)});
  } catch (error) {
    console.error('Error in travelerLoadRemoveEvar47or97Events', error);
  };
};

export const trackNewListingLoad = async (from = {}, to = {}, isV3Listing = false) => {
  const pageName = Platform.OS === 'web' ? 'mob:funnel:rails:listing' : 'mob_rail_listing_v2';
  const data = await _getFunnelLanguageVar('listing')
  const pageObject = getPageObject(pageName);
  updateEvar47or97Variable(`${RAIL_EVENTS.LISTING.RAILS_LOAD_TIME_IMPROVEMENT}_${isV3Listing}`);
  removeEventFromEvar47or97Variable(`${RAIL_EVENTS.LISTING.RAILS_LOAD_TIME_IMPROVEMENT}_${!isV3Listing}`);
  listingLoadRemoveEvar47or97Events();
  const appendEvar3 = from.language === 'eng' && to.language === 'eng';
  _trackEvent(pageName, {
    ...data,
    ..._railsEVars,
    ...pageObject,
      ...(appendEvar3 && { [omniture.VAR_SRC_DEST]: `${from.cityName}-${to.cityName}` }),
  }, true);
};

export const trackBusTrainCrossSellEvents = (isBusPrimaryLob, activeTab) => {
  if (isBusPrimaryLob) {
    switch (activeTab) {
      case 'train':
        trackNewListingCrossSellUsers('Mob_Listing_BusTrains_TrainsProceed', 'add');
        break;
      case 'bus':
        trackNewListingCrossSellUsers('Mob_Listing_BusTrains_TrainsProceed', 'remove');
        break;
    }
  } else {
    switch (activeTab) {
      case 'train':
        trackNewListingClickEvent('Train_Tab_on_Train_listing_clicked');
        break;
      case 'bus':
        trackNewListingClickEvent('Bus_Tab_on_Train_listing_clicked');
        break;
    }
  }
}

export const trackNewListingCrossSellUsers = (event, option) => {
  const pageName = Platform.OS === 'web' ? 'mob:funnel:rails:listing' : 'mob_rail_listing_v2';
  const pageObject = getPageObject(pageName);
  let evar47 = _railsEVars?.[omniture.EVAR_47] || '';
  let evar71 = _railsEVars?.[omniture.EVAR_47] || '';
  const isEventPresent = evar47.split('|').includes(event);
  switch (option) {
    case 'add':
      if (!isEventPresent) {
        switch (evar47 === '') {
          case true:
            evar47 = event;
            evar71 = event;
            break;

          case false:
            evar47 = evar47.split('|').push(event).join('|');
            evar71 = evar71.split('|').push(event).join('|');
            break;
        }
      }
      break;

    case 'remove':
      if (isEventPresent) {
        evar47 = evar47.split('|');
        evar47.splice(evar47.indexOf(event), 1);
        evar47 = evar47.join('|');
        evar71 = evar71.split('|');
        evar71.splice(evar71.indexOf(event), 1);
        evar71 = evar71.join('|');
      }
  }
  _railsEVars = {
    ..._railsEVars,
    [omniture.EVAR_47]: evar47,
    [omniture.EVAR_71]: evar71,
  }
  if (option === 'add') {
    _trackEvent(pageName, {
      ..._railsEVars,
      ...pageObject,
    });
  }
}

export const trackNewListingFromSkyWalker = async () => {
  const data = await _getFunnelLanguageVar('listing')
  const pageName = Platform.OS === 'web' ? 'mob:funnel:rails:listing' : 'mob_rail_listing_v2';
  const pageObject = getPageObject(pageName);
  _trackEvent(pageName, {
    ...data,
    ..._railsEVars,
    ...pageObject,
    [omniture.PROP_61]: `shopper_from_homepage`
  }, true);
};

export const trackRailsCreateNewAccountPageLoad = async () => {
  const data = await _getFunnelLanguageVar('irctc_create_account_form')
  const pageObject = getPageObject('mob_rail_irctc_create_account_form');
  _trackEvent('mob_rail_irctc_create_account_form', {
    ...data,
    ..._railsEVars,
    ...pageObject
  }, true);
};

export const trackRailsCreateNewAccountSuccessPageLoad = async () => {
  const data = await _getFunnelLanguageVar('irctc_create_account_success')
  const pageObject = getPageObject('mob_rail_irctc_create_account_success');
  _trackEvent('mob_rail_irctc_create_account_success', {
    ...data,
    ..._railsEVars,
    ...pageObject
  }, true);
};

export const trackCongratsPageLoad = async () => {
  const data = await _getFunnelLanguageVar('voucher_congrats')
  const pageObject = getPageObject('mob_rail_voucher_congrats');
  _trackEvent('mob_rail_voucher_congrats', {
    ...data,
    ..._railsEVars,
    ...pageObject
  }, true);
};

export const trackCongratsPageClickEvents = (event) => {
  const pageObject = getPageObject('mob_rail_voucher_congrats');
  _trackEvent('mob_rail_voucher_congrats', {
    ..._railsEVars,
    [omniture.PROP_61]: event,
    ...pageObject
  });
};

export const trackFilterBarEvent = (event) =>{
  const pageObject = getPageObject('mob_rail_listing_v2');
  console.log("NEW OMNITURE: ", event);
  _trackEvent('mob_rail_listing_v2', {
    ..._railsEVars,
    [omniture.PROP_61]: event,
    ...pageObject
  });
};

export const trackTravellerBookNow = (event)=>{
  const pageObject = getPageObject('"mob_rail_travellers"');
  updateEvar47or97Variable(event);
  _trackEvent('"mob_rail_travellers"', {
    ...pageObject,
    ..._railsEVars
  });
}

export const trackNewListingSortEvent = (event) => {
  const pageObject = getPageObject('mob_rail_listing_v2');
  _trackEvent('mob_rail_listing_v2', {
    ..._railsEVars,
    [omniture.PROP_61]: event,
    ...pageObject
  });
};

export const trackNewListingFilterEvent = (event) => {
  const pageObject = getPageObject('mob_rail_listing_v2');
  _trackEvent('mob_rail_listing_v2', {
    ..._railsEVars,
    [omniture.PROP_61]: event,
    ...pageObject
  });
};

export const trackFilterPageEvent = (event) => {
  const pageObject = getPageObject('mob_rail_filtersScreen');
  _trackEvent('mob_rail_filtersScreen', {
    ..._railsEVars,
    [omniture.PROP_61]: event,
    ...pageObject
  });
};

export const trackNewListingEvent = (event, commonData) => {
  const pageObject = getPageObject('mob_rail_listing_v2');
  _trackEvent('mob_rail_listing_v2', {
    ..._railsEVars,
    [omniture.PROP_61]: event,
    ...pageObject,
    [omniture.PROP_63]: commonData
  });
};

export const trackNewListingClickEvent = (event) => {
  const pageObject = getPageObject('mob_rail_listing_v2');
  _trackEvent('mob_rail_listing_v2', {
    ..._railsEVars,
    [omniture.PROP_61]: event,
    ...pageObject
  });
};

export const trackNewListingDateChangeEvent = (event, commonData, selectedDateObject) => {
  const pageObject = getPageObject('mob_rail_listing_v2');
  const deptDate = fecha.parse(selectedDateObject.availablityDate, 'DD-MM-YYYY');
  const deptDateFormatted = fecha.format(deptDate, 'DD/MM/YYYY');
  const apDateDiff = diffDays(deptDate, today());
  _railsEVars = {
    ..._railsEVars,
    [omniture.VAR_START_DATE]: deptDateFormatted,
    [omniture.VAR_AP]: apDateDiff
  };
  _trackEvent('mob_rail_listing_v2', {
    ..._railsEVars,
    [omniture.PROP_61]: event,
    ...pageObject,
    [omniture.PROP_63]: commonData
  });
};

export const trackRailsLandingRecentSearches = (data) => {
  const analizeData = {
    [omniture.PROP_61]: data,
    [VAR_PAGE_NAME]: 'mob_rail_landing'
  };
  _trackEvent('mob_rail_landing', analizeData);
};


export const trackPasswordReminderPageLoad = async () => {
  const data = await _getFunnelLanguageVar('password_reminder')
  _trackEvent('mob_rail_next_steps', {
    ...data,
    [omniture.VAR_PAGE_NAME]: 'mob_rail_next_steps'
  });
};

export const trackPasswordReminderPageEvent = (data) => {
  const analizeData = {
    [omniture.PROP_61]: data,
    [VAR_PAGE_NAME]: 'mob_rail_next_steps'
  };
  _trackEvent('mob_rail_next_steps', analizeData);
};

export const trackNeedHelpPageEvent = (data) => {
  const analizeData = {
    [omniture.PROP_61]: data,
    [VAR_PAGE_NAME]: 'mob_rail_irctc_password_after_payments'
  };
  _trackEvent('mob_rail_irctc_password_after_payments', analizeData);
};

export const trackIrctcConnectionTries = (data) => {
  setTimeout(() => {
    const { bookingId, pageName } = data;
    omniture.trackOmniture(pageName, {
      [omniture.VAR_LOB_KEY]: 'rails',
      [omniture.VAR_CHANNEL]: 'rails funnel',
      [omniture.VAR_BOOKING_ID]: bookingId
    }, false);
  }, 0);
}

export const trackStationChangeAlertBottomsheet = (event) => {
  const pageObject = getPageObject(LISTING_NEARBY_STATIONS_BOTTOMSHEET);
  removeEventFromEvar47or97Variable(LISTING_NEARBY_STATIONS_BOTTOMSHEET);
  updateEvar47or97Variable(event);
  _trackEvent(LISTING_NEARBY_STATIONS_BOTTOMSHEET, {
    ..._railsEVars,
    ...pageObject
  });
}

export const trackLoginPersuasionFlow = (loginFlow, pageName) => {
  const pageObject = getPageObject(pageName);
  const pokusKeyMapping = {
    [REGULAR_LOGIN_FLOW] : 'rail_login_persuaision_regular',
    [HARD_LOGIN_FLOW] : 'rail_login_persuaision_hard',
    [SOFT_LOGIN_FLOW] : 'rail_login_persuaision_soft',
    [ANOTHER_TYPE_LOGIN_FLOW] : 'rail_login_persuaision_another_type',
  }
  const flowTypeKey = pokusKeyMapping[loginFlow];
  updateEvar47or97Variable(flowTypeKey);
  _trackEvent(flowTypeKey, {
    ..._railsEVars,
    ...pageObject,
  });
}

export const trackFCBottomSheetPokus = (event)=>{
  const pageObject = getPageObject(TRAVELERS_FC_PROMT);
  updateEvar47or97Variable(event);
  _trackEvent(TRAVELERS_FC_PROMT, {
    ..._railsEVars,
    ...pageObject
  });
}

export const trackContactDetailsOnTravelersPage = (event) => {
  const pageObject = getPageObject(TRAVELERS_CD_PROMT);
  updateEvar47or97Variable(event);
  _trackEvent(TRAVELERS_CD_PROMT, {
    ..._railsEVars,
    ...pageObject
  });
};

export const trackReviewFareBreakupCollapsible = (event) => {
  const pageObject = getPageObject('rails_review_fare_breakup');
  updateEvar47or97Variable(event);
  _trackEvent('rails_review_fare_breakup', {
    ..._railsEVars,
    ...pageObject
  });
}

export const trackTravellerSeatInfo = (pageName,data) => {
  const pageObject = getPageObject(pageName);
  _trackEvent(pageName, {
    ..._railsEVars,
    [omniture.PROP_63]: data,
    ...pageObject
  })
}

export const trackGenericEvar47or97Event = (pageName, event) => {
  const pageObject = getPageObject(pageName);
  updateEvar47or97Variable(event);
  _trackEvent(pageName, {
    ..._railsEVars,
    ...pageObject,
  });
};

export const trackConnectedEvar47or97Event = (pageName, event) => {
  try {
    const evar47or97Variable = _railsEVars?.[evar47or97] ?? '';
    let newEvarVariable = evar47or97Variable;
    //Removing previous  evar
    newEvarVariable = evar47or97Variable
      .split('|')
      .filter((ev) => {
        return ev.includes(LISTING_CONNECTED_TRAVEL_EVENTS.connectedNotShown) ||
          ev.includes(LISTING_CONNECTED_TRAVEL_EVENTS.connectedShown)
          ? ''
          : ev;
      })
      .join('|');
    newEvarVariable += '|';
    _railsEVars = {
      ..._railsEVars,
      [evar47or97]: newEvarVariable
    };
    updateEvar47or97Variable(event);
    if (pageName) {
      //To trigger the tracking for next page load event
      const pageObject = getPageObject(pageName);
      _trackEvent(pageName, {
        ..._railsEVars,
        ...pageObject,
      });
    }
  } catch (error) {
    console.error('Error while tracking Connected travel', error);
  }
};

export const trackOdtEvar47or97Event = (pageName, event) => {
  try {
    const evar47or97Variable = _railsEVars?.[evar47or97] ?? '';
    let newEvarVariable = evar47or97Variable;
    //Removing previous  evar
    newEvarVariable = evar47or97Variable
      .split('|')
      .filter((ev) => {
        return ev.includes(event)
          ? ''
          : ev;
      })
      .join('|');
    newEvarVariable += '|';
    _railsEVars = {
      ..._railsEVars,
      [evar47or97]: newEvarVariable
    };
    updateEvar47or97Variable(event);
    if (pageName) {
      //To trigger the tracking for next page load event
      const pageObject = getPageObject(pageName);
      _trackEvent(pageName, {
        ..._railsEVars,
        ...pageObject,
      });
    }
  } catch (error) {
    console.error('Error while tracking Odt feature', error);
  }
};

export const trackEvar22Event = (pageName, event) => {
  _trackEvent(pageName, {
    [omniture.VAR_ERROR_KEY]: event,
  });
};

export const trackEventAfterRemovingOlderEvent = (pageName, event, prefix) => {
  removeEventFromEvar47or97Variable(prefix);
  trackGenericEvar47or97Event(pageName, event);
};

export const trackConfirmedOptionsClick = () => {
  removeEventFromEvar47or97Variable(
    `${RAIL_EVENTS.LISTING.RAIL_LISTING_CONFIRMED_OPTIONS_CLICKED}`,
  );
  trackGenericEvar47or97Event(
    LISTING_PAGE_TRACKING_KEY,
    RAIL_EVENTS.LISTING.RAIL_LISTING_CONFIRMED_OPTIONS_CLICKED,
  );
};

export const trackFCTGEvar47or97Event = (pageName, event, prefix) => {
  try {
    const evar47or97Variable = _railsEVars?.[evar47or97] ?? '';
    let newEvarVariable = evar47or97Variable;
    //Removing previous FC / TG evar
    newEvarVariable = evar47or97Variable
      .split('|')
      .filter((event) => {
        const isEventTracked =
          event.includes(RAIL_EVENTS.FCTG.FC) ||
          event.includes(RAIL_EVENTS.FCTG.TG) ||
          event.includes(RAIL_EVENTS.FCTG.TGP_SELECTED) ||
          event.includes(RAIL_EVENTS.FCTG.TGP_UNSELECTED);
        return event.includes('rails_FC_TG')
          ? event
          : isEventTracked
          ? ''
          : event;
      })
      .join('|');
    newEvarVariable += '|';
    _railsEVars = {
      ..._railsEVars,
      [evar47or97]: newEvarVariable
    };
    updateEvar47or97Variable(event);
    if (pageName) { //To trigger the tracking for next page load event
      const pageObject = getPageObject(pageName);
      _trackEvent(pageName, {
        ..._railsEVars,
        ...pageObject,
      });
    }
  } catch (error) {
    console.error('Error while tracking fc tg', error);
  }
};

export const updateEvar47or97Variable = (evar47or97Event) => {
  let evar47or97Variable = _railsEVars?.[evar47or97] ?? '';
  const eventTag = `${evar47or97Event}|`;
  if (!evar47or97Variable.split('|').includes(evar47or97Event)) {
    evar47or97Variable += eventTag;
    _railsEVars = {
      ..._railsEVars,
      [evar47or97]: evar47or97Variable
    };
  }

  setDataInStorage(RAIL_TRACKING_DATA_EVAR_47, _railsEVars?.[evar47or97]);
};

export const removeEventFromEvar47or97Variable = (eventPrefix) => {
  const evar47or97Variable = _railsEVars?.[evar47or97] ?? '';
  let newEvarVariable = evar47or97Variable;
  if(evar47or97Variable.includes(eventPrefix)) {
    newEvarVariable = evar47or97Variable.split('|').
                      filter((event) => {
                      return event.includes(eventPrefix) ? '' : event
                      }).
                      join('|');
    newEvarVariable += '|';
  }
  _railsEVars = {
    ..._railsEVars,
    [evar47or97]: newEvarVariable
  };
  setDataInStorage(RAIL_TRACKING_DATA_EVAR_47, _railsEVars?.[evar47or97]);
};

export const trackGenericEvar99Event = (pageName, event) => {
  const pageObject = getPageObject(pageName);
  updateEvar99Variable(event);
  const mergedObject = Object.assign({}, _railsEVars, pageObject);
  _trackEvent(pageName, mergedObject);
};

export const updateEvar99Variable = (evar99Event) => {
  try {
    if (!evar99Event) {
      return;
    }
    let evar99Variable = _railsEVars[omniture.EVAR_99] ? _railsEVars[omniture.EVAR_99] : '';
    const eventTag = `${evar99Event}|`;

    if (!evar99Variable.split('|').includes(evar99Event)) {
      evar99Variable += eventTag;
      Object.assign(_railsEVars, { [omniture.EVAR_99]: evar99Variable });
    }
  } catch (error) {
    console.error('Error while updating evar99', error);
  }
};

export const removeEventFromEvar99Variable = (eventPrefix) => {
  try {
    const evar99Variable = _railsEVars[omniture.EVAR_99] ? _railsEVars[omniture.EVAR_99] : '';
    let newEvarVariable = evar99Variable;
    if (evar99Variable.includes(eventPrefix)) {
      newEvarVariable = evar99Variable
        .split('|')
        .filter((event) => {
          return event.includes(eventPrefix) ? '' : event;
        })
        .join('|');
      newEvarVariable += '|';
    }
    Object.assign(_railsEVars, { [omniture.EVAR_99]: newEvarVariable });
  } catch (error) {
    console.error('Error while removing evar99', error);
  }
};

const checkIfEvarPresent = (evar47or97Event) => {
  if(_.isEmpty(_railsEVars)) return false;
  const evar47or97Variable = _railsEVars?.[evar47or97] ?? '';
  return evar47or97Variable?.includes(evar47or97Event);
};

